import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { FormProps } from '../types';

const Form = forwardRef<HTMLFormElement, FormProps>((props, ref) => <form ref={ref} {...props} noValidate />);

export default styled(Form)``;
